export * from '@primeuix/themes/material/fileupload';
export { default } from '@primeuix/themes/material/fileupload';
